import { Text } from '@mantine/core';
import classes from './logo.module.css';

/**
 * The Fluently mark on its own.
 *
 * Deliberately `favicon-256.png` and not `apple-touch-icon.png`: only the
 * favicon carries its rounded corners in the alpha channel. The apple-touch
 * icon is square and opaque by design, because iOS applies its own mask, and
 * in a page it renders as a hard-cornered square. See docs/assets.md.
 */
export function LogoMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src="/favicon-256.png"
      alt=""
      width={size}
      height={size}
      className={classes.mark}
    />
  );
}

interface LogoProps {
  /** Height of the wordmark in pixels. The mark is sized to match. */
  height?: number;
  /** Appends the muted "Admin" label. Off for the sign-in screen, which says so in its heading. */
  withSuffix?: boolean;
}

/**
 * Mark plus wordmark. The wordmark is a raster at 1401 x 334, so width is left
 * to `auto` and only the height is set — no vector original survives.
 */
export function Logo({ height = 18, withSuffix = true }: LogoProps) {
  return (
    <span className={classes.lockup}>
      <LogoMark size={height + 10} />
      <img
        src="/fluently-wordmark.png"
        alt="Fluently"
        height={height}
        className={classes.wordmark}
        style={{ height }}
      />
      {withSuffix && (
        <Text component="span" size="sm" c="dimmed" fw={500} visibleFrom="xs">
          Admin
        </Text>
      )}
    </span>
  );
}
